
import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import ic_logo from "../img/ic_exclusive_app_logo.jpg";
import company_logo from "../img/company_header_for_pdf.jpeg";


// Create styles
const styles = StyleSheet.create({

  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    paddingTop: 20,
    paddingBottom: 25,
    paddingHorizontal: 25,
  },

  headerPanel: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  leftRightBoxContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  leftBox: {
    width: "48%",
    borderWidth: 1,
  },
  rightBox: {
    width: "48%",
    borderWidth: 1,
  },

  leftBoxHeading: {
    flexDirection: "row",
    backgroundColor: "#767676",
    color: "#ffffff",
    fontSize: 11,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 10,

  },

  rightBoxHeading: {
    flexDirection: "row",
    backgroundColor: "#767676",
    color: "#ffffff",
    fontSize: 11,
  },

  leftBoxCustName: {
    fontSize: 11,
  },

  tableHeading: {
    backgroundColor: "#767676",
    color: "#ffffff",
    flexDirection: 'row',
    alignItems: 'center',
    height: 24,
    fontSize: 11,
    marginTop: 5,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 24,
    fontSize: 11,
  },

  column: {
    width: '20%',
    textAlign: 'right',
    paddingRight: 8,
  },

  rowWiseElement: {
    flexDirection: "row",
    fontSize: 11,
    justifyContent: "space-between",
    margin: 4,
  },
  rowWiseElementSubTotal: {
    flexDirection: "row",
    fontSize: 13,
    justifyContent: "space-between",
    margin: 4,
  },

  rowWiseElementTotal: {
    flexDirection: "row",
    fontSize: 15,
    justifyContent: "space-between",
    margin: 4,
  },
  rowWiseElementItemList: {
    flexDirection: "row",
    fontSize: 11,
    marginTop: 3,
    color: "#4c4c4c",
  },
  centerWiseElement: {
    flexDirection: "row",
    justifyContent: "center",
  },
  statementOfAccount: {
    fontSize: 11,
    color: "#282873",
    marginTop: 3,
  },
  trnNumber: {
    fontSize: 11,
    color: "#000000",
    marginTop: 5,
    marginBottom: 10,
  },
  headerLogo: {
    width: "75%",
  },
  underlineGrey: {
    width: "100%",
    height: 1,
    backgroundColor: "#767676",
    marginBottom: 1,
  },
  underlineRed: {
    width: "100%",
    height: 2,
    backgroundColor: "#f00",
  },
  greenBorderView: {
    borderLeftWidth: 3,
    borderLeftColor: "#008000",
    fontSize: 10,
    marginRight: 20,
    paddingLeft: 5,
  },

  redBorderView: {
    borderLeftWidth: 3,
    borderLeftColor: "#ff0000",
    fontSize: 10,
    paddingLeft: 5,
  },

  headerRightSectionBottom: {
    borderLeftWidth: 3,
    borderLeftColor: "#0000ff",
    fontSize: 10,
    paddingLeft: 5,
  },
  headerRightSection: {
    flexDirection: "column",
  },
  headerRightSectionTop: {
    marginBottom: 10,
    flexDirection: "row",
  },
  leftBoxChild: {
    padding: 5,
  },
  phonelabel: {
    marginTop: 5,
  },
  itemListSingleRowContainer: {
    flexDirection: "row",
    paddingTop: 10,
    paddingBottom: 10,
  },
  itemName: {
    fontSize: 13,
    marginTop: 5,
  },


  itemCodeContainer: {
    flexDirection: "row",
  },
  itemCode: {
    fontSize: 12,
    backgroundColor: "#ededed",
    padding: 4,
  },
  itemLineTotal: {
    fontSize: 13,
  },
  customerLabel: {
    marginTop: 10,
    fontSize: 10,
    color: "#767676",
  },

  itemListLabel: {
    fontSize: 10,
    color: "#767676",
    marginTop: 20,
    marginBottom: 10,
  },
  customerValue: {
    fontSize: 11,
    marginTop: 5,
  },
  orderRemarkLabel: {
    fontSize: 10,
    color: "#767676",
    marginTop: 20,
  },
  belowItemListContainer: {
    backgroundColor: "#f5f5f5",
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 10,
    fontSize: 14,
    fontWeight: 600,
    color: "#000000",
  },
  subotalContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    color: "#000000",
    fontWeight: 600,
    fontSize: 14,
  },
  aboveOrderListContainer: {
    marginTop: 2,
  },
  headingContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  headingContainerLabel: {
    fontSize: 10,
    color: "#767676",
    marginRight: 10,
  },
  headingContainerValue: {
    fontSize: 11,
    color: "#000000",
  },
  detailsOfOrderContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    marginBottom: 2,
    paddingBottom: 2,
  },
  logoImage: {
    width: "100%",
  },
  logoContainer: {
    flexDirection: "row",
    justifyContent: "center",
  },

  itemListSingleRowContainerHeader: {
    flexDirection: "row",
    fontSize: 11,
    backgroundColor: "#f7f7f7",
    borderTopWidth: 1,
    borderTopColor: "#000000",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    paddingTop: 3,
    paddingBottom: 3,
  },
  itemSlNoTableHeader: {
    width: "5%",
  },
  itemCodeTableHeader: {
    width: "15%",
  },
  itemDescriptionTableHeader: {
    width: "18%",
  },
  itemPriceTableHeader: {
    width: "8%",
    textAlign: "right",
  },
  itemQuantityTableHeader: {
    width: "8%",
    textAlign: "right",
  },
  itemRemarkTableHeader: {
    width: "20%",
  },
  itemBarcodeTableHeader: {
    width: "14%",
  },
  itemTotalTableHeader: {
    width: "12%",
    textAlign: "right",
  },

  itemSlNoTableHeaderValue: {
    width: "5%",
    fontSize: 10,
  },
  itemCodeTableHeaderValue: {
    width: "15%",
    fontSize: 10,
  },
  itemDescriptionTableHeaderValue: {
    width: "18%",
    fontSize: 10,
    textAlign: "left",
  },
  itemPriceTableHeaderValue: {
    width: "8%",
    fontSize: 10,
    textAlign: "right",
  },
  itemQuantityTableHeaderValue: {
    width: "8%",
    fontSize: 10,
    textAlign: "right",
  },
  itemRemarkTableHeaderValue: {
    width: "20%",
    fontSize: 10,
  },
  itemBarcodeTableHeaderValue: {
    width: "14%",
    fontSize: 10,
  },
  itemTotalTableHeaderValue: {
    width: "12%",
    textAlign: "right",
    fontSize: 10,
  },
  quotationHeading: {
    textAlign: "center",
    marginTop: 5,
    marginBottom: 5,
  }



});


// Create Document Component
const MyDocument = (props) => {


  const getMonth2Digits = (date) => {

    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    // 👇️ Add 1, because getMonth is 0-11
    // const month = date.getMonth() + 1;

    const month = monthNames[date.getMonth()];

    // if (month < 10) {
    //   return '0' + month;
    // }

    return month;
  }

  const getDay2Digits = (date) => {
    const day = date.getDate();

    if (day < 10) {
      return '0' + day;
    }

    return day;
  }

  const getCurrentDate = (dateFromDb) => {

    if (dateFromDb != null) {

      let today = new Date(dateFromDb);
      let date = (getDay2Digits(today) + '-' + getMonth2Digits(today)) + '-' + today.getFullYear();
      console.log("getCurrentDate is ", date);
      return date;
    }
  }

  return (
    <Document >
      <Page size="A4" style={styles.page}>

        <View style={styles.logoContainer}>
          <Image src={company_logo} style={styles.logoImage} />
        </View>

        <View>
          <Text style={styles.quotationHeading}>Quotation</Text>
        </View>

        {
          props.listOfStatement != null ?

            <View style={styles.detailsOfOrderContainer}>
              <View style={styles.headingContainer}>
                <Text style={styles.headingContainerLabel}>Date : </Text>
                <Text style={styles.headingContainerValue}>{getCurrentDate(props.listOfStatement[0].so_date)}</Text>
              </View>
              <View style={styles.headingContainer}>
                <Text style={styles.headingContainerLabel}>Order Number : </Text>
                <Text style={styles.headingContainerValue}> {props.invoiceState}</Text>
              </View>
            </View>
            :
            null
        }




        <View style={styles.aboveOrderListContainer}>

          <Text style={styles.customerLabel}>Customer Code</Text>
          <Text style={styles.customerValue}> {props.custAccountStatement != null ? props.custAccountStatement : "--"}</Text>

          <Text style={styles.customerLabel}>Customer</Text>
          <Text style={styles.customerValue}> {props.custNameStatement != null ? props.custNameStatement : "--"}</Text>

          {
            props.listOfStatement != null ?
              <Text style={styles.customerValue}>{props.listOfStatement[0].address1},{props.listOfStatement[0].address2},{props.listOfStatement[0].address3}</Text>
              :
              null
          }

        </View>

        <View style={styles.orderRemarkContainer}>
          <Text style={styles.orderRemarkLabel}>Order Remark</Text>
          {props.listOfStatement != null ?
            (props.listOfStatement[0].OrderRemark) != null ?
              (props.listOfStatement[0].OrderRemark).length > 0 ?
                <Text style={styles.customerValue}> {props.listOfStatement[0].OrderRemark} </Text>
                :
                <Text style={styles.customerValue}>---</Text>
              :
              <Text style={styles.customerValue}>---</Text>
            :
            null
          }
        </View>

        <Text style={styles.itemListLabel}>Item List</Text>

        <View style={styles.itemListSingleRowContainerHeader}>
          <Text style={styles.itemSlNoTableHeader}> Sl. No. </Text>
          <Text style={styles.itemCodeTableHeader}> Item Code </Text>
          <Text style={styles.itemDescriptionTableHeader}> Description </Text>
          <Text style={styles.itemRemarkTableHeader}> Remark  </Text>
          <Text style={styles.itemBarcodeTableHeader}> Barcode </Text>
          <Text style={styles.itemPriceTableHeader}> Price</Text>
          <Text style={styles.itemQuantityTableHeader}> QTY</Text>
          <Text style={styles.itemTotalTableHeader}>Amount</Text>
        </View>

        {
          props.listOfStatement != null ?

            props.listOfStatement.map((item, index) => {
              return (
                <View style={styles.itemListSingleRowContainer}>
                  <Text style={styles.itemSlNoTableHeaderValue}> {index + 1} </Text>
                  <Text style={styles.itemCodeTableHeaderValue}> {item.so_icode} </Text>
                  <Text style={styles.itemDescriptionTableHeaderValue}> {item.idesc} </Text>
                  <Text style={styles.itemRemarkTableHeaderValue}> {item.ItemWiseRemark} </Text>
                  <Text style={styles.itemBarcodeTableHeaderValue}> {item.BarcodeRemark != null ? item.BarcodeRemark : item.batch} </Text>
                  <Text style={styles.itemPriceTableHeaderValue}> {item.so_cost} </Text>
                  <Text style={styles.itemQuantityTableHeaderValue}> {item.tr_qty2} </Text>
                  <Text style={styles.itemTotalTableHeaderValue}>{parseFloat((item.line_total).toFixed(2))}</Text>
                </View>
              )
            })

            : <Text>No Data</Text>
        }

        {
          props.listOfStatement != null ?
            <View>
              <View style={styles.subotalContainer}><Text>Subtotal</Text><Text>

                {props.listOfStatement != null ? props.listOfStatement.reduce((acc, curr) => {

                  return acc = acc + Math.round((curr.tr_qty2 * curr.so_cost) * 100) / 100

                }, 0).toLocaleString('en-US', { maximumFractionDigits: 2 }) : null} </Text></View>

            </View>
            :
            null
        }

        {
          props.listOfStatement != null ?

            <View style={styles.belowItemListContainer}>
              <View style={styles.rowWiseElementSubTotal}><Text>VAT % : </Text><Text>5%</Text></View>
              <View style={styles.rowWiseElementSubTotal}><Text>VAT : </Text><Text>

                {props.listOfStatement != null ?

                  ((props.listOfStatement.reduce((acc, curr) => {

                    return acc = acc + Math.round((curr.tr_qty2 * curr.so_cost) * 100) / 100

                  }, 0) * 5) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 })

                  :
                  null
                }
              </Text></View>
              <View style={styles.rowWiseElementTotal}><Text>Amount Incl.VAT</Text><Text>{parseFloat((props.listOfStatement[0].so_amount).toFixed(2))}</Text></View>
            </View>
            :
            null
        }

      </Page>


    </Document>
  )
}

export default MyDocument;